export const APP_VERSION = '1.8.2';
export const APP_BUILD   = '2026-06-23';
